import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { Store } from '@ngxs/store';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs';

import { UiActions } from '@store/actions/ui.actions';

@Component({
  selector: 'cito-doe-on-screen-info',
  imports: [TranslateModule, ButtonModule],
  templateUrl: './on-screen-info.component.html',
  styleUrls: ['./on-screen-info.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnScreenInfoComponent implements OnInit {
  translateKey!: string;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private cdr: ChangeDetectorRef,
  ) {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      this.translateKey = this.activatedRoute.snapshot?.firstChild?.data?.['label'];
      this.cdr.detectChanges();
    });
  }

  ngOnInit() {
    this.translateKey = this.activatedRoute.snapshot?.firstChild?.data?.['label'];
  }

  closeOnScreenInfo() {
    this.store.dispatch(new UiActions.closeOnScreenInfo());
  }
}
